import { ChangeDetectorRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { InjectorKeys } from '../utils/injector.keys';
import { EmployeeDetailsService } from '../services/employee/employee.details.service';
import { Observable, of } from 'rxjs';
import { PLACEHOLDER_IMAGE } from '../utils/utils';

/**
 * Pipe to download the profile images from the backend, and cache them. The caching just applies to the last file (so
 * consecutive calls with the same value will not trigger a new download).
 */
@Pipe({
  name: 'profileImage',
  pure: true,
  standalone: false
})
export class ProfileImagePipe implements PipeTransform {
  constructor(
    @Inject(InjectorKeys.EMPLOYEE_DETAILS_SERVICE) private service: EmployeeDetailsService,
  ) {}

  /**
   * Transforms the input value into an Observable of the image URL.
   * @param value The user identifier (e.g., email), which can be string, null, or undefined.
   */
  transform(value: string | null | undefined): Observable<string> {
    if (!value) {
      return of(PLACEHOLDER_IMAGE);
    }
    return this.service.getProfileImage(value);
  }
}
